<template>
  <detail
    envName="种植环境"
    :envInfoType="1" />
</template>

<script>
import Detail from '@/components/business/traceinfo/detail'
export default {
  name: 'PlatEnvDetail',
  components: { Detail },
  props: {},
  data() {
    return {}
  },
  computed: {},
  watch: {},
  created() { },
  mounted() { },
  methods: {}
}
</script>
<style lang="stylus" scoped></style>
